import config from 'config';

export const withApiBaseUrl = (path: string) => {
  const normalizedPath = path?.startsWith('/') ? path : `/${path}`;

  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.host}${normalizedPath}`;
  }

  return `${config.apiBaseUrl}${normalizedPath}`;
};
